
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderModel } from './Entities.GormCrm.Order';
import { Model, ModelProperty } from 'models/Model';


export class SaleAttachmentModel extends Model<SaleAttachmentModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'userId', type: 'string' },
		{ name: 'orderId', type: 'string' },
		{ name: 'fileName', type: 'string' },
		{ name: 'uploaded', type: 'Date' },
		{ name: 'temporary', type: 'boolean' },
		{ name: 'companyId', type: 'string' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public userId?: string;
	public orderId?: string;
	public fileName: string;
	public uploaded?: Date;
	public temporary: boolean;
	public companyId?: string;
	public company?: CompanyModel;
	public order?: OrderModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.userId = undefined;
		this.orderId = undefined;
		this.fileName = '';
		this.uploaded = undefined;
		this.temporary = false;
		this.companyId = undefined;
		this.company = undefined;
		this.order = undefined;
		
	}
	getProperties(){
		return SaleAttachmentModel.classProperties;
	}
}

